import React, {useState, useContext, useEffect} from 'react'
import ConfigContext from '../contexts/configContext'
import FormInputs from './FormInputs';
import Button from '@mui/material/Button';
import Rating from '@mui/material/Rating';
import FormControl from '@mui/material/FormControl';

export default function PreCallForm({onSubmit, onSkip}) {
  const config = useContext(ConfigContext)
  const [rating, setRating] = useState(null)
  const [ratingPrecision, setRatingPrecision] = useState(1.0)
  const [ratingMax, setRatingMax] = useState(5.0)
  const [ratingDefault, setRatingDefault] = useState(0.0)
  const [ratingThreshold, setRatingThreshold] = useState(3.0)
  const [ratingWebhookThreshold, setRatingWebhookThreshold] = useState(3.0)
  const [inputs, setInputs] = useState([])
  const [hasAllRequired, setHasAllRequired] = useState(false)
  const [webhookUrl, setWebhookUrl] = useState(null)
  const [webhookParams, setWebhookParams] = useState({})
  const [closeTimeout, setCloseTimeout] = useState(null)
  const [enableSkipButton, setEnableSkipButton] = useState(true)

  useEffect(() => {
    if (config?.feedbackform?.hasOwnProperty('inputs')) setInputs(config.feedbackform.inputs)
    if (config?.feedbackform?.hasOwnProperty('resultWebhook')) setWebhookUrl(config.feedbackform.resultWebhook)
    if (config?.feedbackform?.hasOwnProperty('ratingPrecision')) setRatingPrecision(config.feedbackform.setRatingPrecision)
    if (config?.feedbackform?.hasOwnProperty('ratingMax')) setRatingMax(config.feedbackform.setRatingMax)
    if (config?.feedbackform?.hasOwnProperty('ratingDefaultValue')) setRatingDefault(config.feedbackform.ratingDefaultValue)
    if (config?.feedbackform?.hasOwnProperty('ratingThreshold')) setRatingThreshold(config.feedbackform.ratingThreshold)
    if (config?.feedbackform?.hasOwnProperty('ratingWebhookThreshold')) setRatingWebhookThreshold(config.feedbackform.ratingWebhookThreshold)
    if (config?.feedbackform?.hasOwnProperty('enableSkipButton')) setEnableSkipButton(config.feedbackform.enableSkipButton)
  }, [])

  useEffect(() => {
    if (!rating || !ratingThreshold) return
    clearTimeout(closeTimeout)
    if (rating > ratingThreshold) {
        let t = setTimeout(() => {
            onSubmit()
        },5000)
        setCloseTimeout(t)
    }
  }, [rating, ratingThreshold])

  const callWebhook = async () => {
    const response = await fetch(webhookUrl, {
        method: 'POST',
        body: JSON.stringify(webhookParams),
    });
  };

  const handleRatingChange = (e) => {
    setRating(e.target.value);
  }

  return (
    <div className='live-call-feedbackform'>
        <h1>
            {config?.feedbackform?.headerTxt
                ? config.feedbackform.headerTxt
                : "How was your call?"
            }
        </h1>
        <div className='live-call-feedbackform-rating'>
            <FormControl fullWidth margin='normal'>
                <Rating 
                    id='feedback-rating'
                    name='feedback-rating'
                    defaultValue={ratingDefault}
                    onChange={handleRatingChange}
                    precision={ratingPrecision}
                    max={ratingMax}
                    size='large'
                    sx={{
                        fontSize: "4rem",
                        marginLeft: 'auto',
                        marginRight: 'auto',
                    }}
                />
            </FormControl>
        </div>
        {!rating && enableSkipButton ? 
                <Button 
                    sx={{m:1}}
                    variant="contained"
                    size="large"
                    onClick={() => onSkip()}
                >
                    {config?.feedbackform?.skipButtonTxt
                        ? config.feedbackform?.skipButtonTxt
                        : "Skip"
                    }
                </Button>
        : null}
        {rating && rating <= ratingThreshold ?
            <>
                <FormInputs
                    formInputs={inputs}
                    onHasAllRequired={hasAll => setHasAllRequired(hasAll)}
                    onWebhookParamsChange={params => setWebhookParams(params)}
                />
                <Button 
                    disabled={!hasAllRequired}
                    sx={{m:1}}
                    variant="contained"
                    size="large"
                    onClick={() => {
                        if (
                            webhookUrl 
                            && Object.keys(webhookParams).length > 0
                            && rating <= ratingWebhookThreshold
                            ) callWebhook()
                        onSubmit()
                    }}
                >
                    {config?.feedbackform?.submitButtonTxt
                        ? config.feedbackform?.submitButtonTxt
                        : "Submit"
                    }
                </Button>
            </>
        : null}
    </div>
  )
}
